import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/image/logo.png';
import './Sidebar.css';
import { authAPI } from '../../api/authApi';

const IconHome = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
    <polyline points="9 22 9 12 15 12 15 22"></polyline>
  </svg>
);

const IconChart = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10"></line>
    <line x1="12" y1="20" x2="12" y2="4"></line>
    <line x1="6" y1="20" x2="6" y2="14"></line>
  </svg>
);

const IconUsers = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

const IconSettings = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const IconHelp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
    <line x1="12" y1="17" x2="12.01" y2="17"></line>
  </svg>
);

const IconMenu = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="4" y1="12" x2="20" y2="12"></line>
    <line x1="4" y1="6" x2="20" y2="6"></line>
    <line x1="4" y1="18" x2="20" y2="18"></line>
  </svg>
);

const IconChevronLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m15 18-6-6 6-6"></path>
  </svg>
);

const IconLogOut = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="red" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
);

const IconChevronDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m6 9 6 6 6-6"></path>
  </svg>
);

const IconChevronUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m18 15-6-6-6 6"></path>
  </svg>
);

const IconInfo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

const IconDocument = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14 2 14 8 20 8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10 9 9 9 8 9"></polyline>
  </svg>
);

const IconDashboard = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7"></rect>
    <rect x="14" y="3" width="7" height="7"></rect>
    <rect x="14" y="14" width="7" height="7"></rect>
    <rect x="3" y="14" width="7" height="7"></rect>
  </svg>
);

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(window.innerWidth > 768);
  const [showInfoDropdown, setShowInfoDropdown] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const getActiveItemFromPath = (path) => {
    switch (path) {
      case '/': return 'Home';
      case '/notification': return 'Notificação';
      case '/follow': return 'Acompanhar';
      case '/dashboard': return 'Dashboard';
      case '/documentation': return 'Documentação';
      case '/settings': return 'Configurações';
      case '/help': return 'Ajuda';
      case '/classroom': return 'Aulas';
      case '/students': return 'Alunos';
      case '/reports': return 'Relatórios';
      case '/personal-data': return 'Dados pessoais';
      default: return 'Home';
    }
  };

  const [activeItem, setActiveItem] = useState(getActiveItemFromPath(location.pathname));

  useEffect(() => {
    setActiveItem(getActiveItemFromPath(location.pathname));
  }, [location.pathname]);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const toggleInfoDropdown = () => setShowInfoDropdown(!showInfoDropdown);

  const handleNavigation = (title) => {
    setActiveItem(title);
    switch (title) {
      case 'Home': navigate('/'); break;
      case 'Notificação': navigate('/notification'); break;
      case 'Acompanhar': navigate('/follow'); break;
      case 'Dashboard': navigate('/dashboard'); break;
      case 'Documentação': navigate('/documentation'); break;
      case 'Configurações': navigate('/settings'); break;
      case 'Ajuda': navigate('/help'); break;
      case 'Aulas': navigate('/classroom'); break;
      case 'Alunos': navigate('/students'); break;
      case 'Relatórios': navigate('/reports'); break;
      case 'Dados pessoais': navigate('/personal-data'); break;
      default: break;
    }
  };

  const handleLogout = async () => {
    try {
      await authAPI.logout();
    } catch (error) {
      console.error('Erro durante logout:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('rememberMe');
      localStorage.removeItem('email');
      sessionStorage.clear();

      window.location.replace('/login');
    }
  };

  const menuItems = [
    { icon: <IconHome />, title: 'Home' },
    { icon: <IconChart />, title: 'Notificação' },
    { icon: <IconUsers />, title: 'Acompanhar' },
    {
      icon: <IconInfo />,
      title: 'Informações',
      hasDropdown: true,
      action: toggleInfoDropdown
    },
    { icon: <IconDashboard />, title: 'Dashboard' },
    { icon: <IconDocument />, title: 'Documentação' },
  ];

  const footerItems = [
    { icon: <IconSettings />, title: 'Configurações' },
    { icon: <IconHelp />, title: 'Ajuda' },
    { icon: <IconLogOut />, title: 'Sair', action: handleLogout, className: 'logout-button' }
  ];

  const infoDropdownItems = [
    { title: 'Aulas', path: '/classroom' },
    { title: 'Alunos', path: '/students' },
    { title: 'Relatórios', path: '/reports' },
    { title: 'Dados pessoais', path: '/personal-data' }
  ];

  return (
    <div className="app-container">
      <div className={`sidebar-overlay ${isOpen ? 'active' : ''}`} onClick={toggleSidebar} />
      <div className={`sidebar ${isOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="sidebar-header">
          {isOpen && <img src={logo} alt="Logo" className="sidebar-logo" />}
          <button onClick={toggleSidebar} className={`toggle-button ${isOpen ? 'right-aligned' : 'center-aligned'}`}>
            {isOpen ? <IconChevronLeft /> : <IconMenu />}
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul className="menu-list">
            {menuItems.map((item, index) => (
              <li key={index} className="menu-item">
                <button
                  onClick={() => item.action ? item.action() : handleNavigation(item.title)}
                  className={`menu-button ${activeItem === item.title ? 'menu-button-active' : ''}`}
                >
                  <span className={`menu-icon ${activeItem === item.title ? 'menu-icon-active' : ''}`}>
                    {item.icon}
                  </span>
                  {isOpen && (
                    <div className="menu-content">
                      <span className="menu-text">{item.title}</span>
                      {item.hasDropdown && (
                        <span className="dropdown-icon">
                          {showInfoDropdown ? <IconChevronUp /> : <IconChevronDown />}
                        </span>
                      )}
                    </div>
                  )}
                </button>

                {item.title === 'Informações' && showInfoDropdown && isOpen && (
                  <ul className="dropdown">
                    {infoDropdownItems.map((dropItem, idx) => (
                      <li
                        key={idx}
                        className={`dropdown-item ${activeItem === dropItem.title ? 'dropdown-item-active' : ''}`}
                        onClick={() => {
                          handleNavigation(dropItem.title);
                        }}
                      >
                        {dropItem.title}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </nav>

        <div className="sidebar-footer">
          <div className="footer-menu">
            {footerItems.map((item, index) => (
              <button
                key={index}
                onClick={() => item.action ? item.action() : handleNavigation(item.title)}
                className={`footer-button ${activeItem === item.title ? 'footer-button-active' : ''} ${item.className || ''}`}
              >
                <span className={`menu-icon ${activeItem === item.title ? 'menu-icon-active' : ''}`}>
                  {item.icon}
                </span>
                {isOpen && <span className={`footer-text ${activeItem === item.title ? 'footer-text-active' : ''}`}>{item.title}</span>}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}